import { Pipe, PipeTransform } from '@angular/core';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Specialite } from 'src/app/shared/models/specialite';

@Pipe({
	name: 'filterEmployeeBySpecialties'
})
export class FilterEmployeeBySpecialtiesPipe implements PipeTransform {
	transform(employees: Employee[], specialties: Specialite[]): Employee[] {
		if (
			employees === null ||
			!employees ||
			(Array.isArray(employees) && employees.length === 0) ||
			specialties === null ||
			(Array.isArray(specialties) && specialties.length === 0)
		) {
			return employees;
		}

		return employees.filter((employee) => {
			return employee.specialties.some((spe) =>
				specialties
					.map((spec) => spec.name)
					.some((specStr) => specStr.includes(spe.name))
			);
		});
	}
}
